import { State, Action, StateContext, Selector } from '@ngxs/store';
import { ViewStateModel } from './view.state.model';
import { ShowPanel, CollapsePanel, ResetView, ShowColumn } from './view.actions';

const initialState = {
  showPanel: false,
  collapsePanel: false,
  showColumn: true
};

@State<ViewStateModel>({
  name: 'view',
  defaults: initialState
})
export class ViewState {
  /**
   * Selectors
   */
  @Selector()
  static getShowPanel(state: ViewStateModel) {
    return state.showPanel;
  }

  @Selector()
  static getCollapsePanel(state: ViewStateModel) {
    return state.collapsePanel;
  }

  @Selector()
  static getShowColumn(state: ViewStateModel) {
    return state.showColumn;
  }

  /**
   * Actions
   */
  @Action(ShowPanel)
  showPanel(context: StateContext<ViewStateModel>, action: ShowPanel) {
    context.patchState({
      showPanel: action.show
    });
  }

  @Action(ShowColumn)
  showColumn(context: StateContext<ViewStateModel>, action: ShowColumn) {
    context.patchState({
      showColumn: action.show
    });
  }

  @Action(CollapsePanel)
  collapsePanel(context: StateContext<ViewStateModel>, action: CollapsePanel) {
    context.patchState({
      collapsePanel: action.collapse
    });
  }

  @Action(ResetView)
  resetView(context: StateContext<ViewStateModel>, action: ResetView) {
    context.setState(initialState);
  }

  constructor() { }
}
